/**
 * @author PengWen
 * @description 岗位兼职信息管理页面配置
 * @Date 2022/11/28
 */

import {component_tool, framework_tool ,utils_tool} from '../../../tool';
import { WizTableForm } from '../../common'
let {WizModal} = component_tool;
let { $$ } = utils_tool;
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 , organizationNodeCategory:["2"]} })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

//配置项
let componentName = 'RequirementPartTimePosition'

const columns = [
    {
        name: "id",
        fromItem: {
          type: "hidden"
        }
    },
    {
        title: "组织",
        name: "name",
        tableItem: {
          width: 200
        },
    },
    {
        title: "组织",
        name: "orgId",
        searchItem: {
          diy: WizTableForm,
          selectType:"radio",
          ...organizationConfig
        }
    },
    {
        title: "岗位",
        name: "positionIds",
        tableItem: {
          width: 300
        },
    },
    {
        title: "岗位",
        name: "positionIdA",
        searchItem: {
            diy: WizTableForm,
            selectType:"radio",
            ...positionConfig,
        },
    },
    {
        title: "站点类型",
        name: "dealerTypeCh",
        tableItem: {
          width: 400
        },
    },
    {
        title: "站点类型",
        name: "dealerType",
        searchItem: {
            type: 'select',
        },
        dict: [
            { code: 1, codeName: '4S网点' },
            { code: 2, codeName: '直营店' },
            { code: 3, codeName: '单一售后' },
            { code: 4, codeName: '单一销售' },
            { code: 5, codeName: '卫星店/直营店' },
            { code: 6, codeName: '自修站' },
            { code: 7, codeName: '卫星店' },
            { code: 8, codeName: '精品店' },
            { code: 9, codeName: 'dealer' },
            { code: 10, codeName: '4S店' },
            { code: 11, codeName: '汽车零售' },
            { code: 12, codeName: '单一销售展厅' },
            { code: 13, codeName: 'NEV单一售后' },
            { code: 14, codeName: '轻量化4S网点' },
            { code: 15, codeName: 'NEV专区' },
            { code: 16, codeName: '商超店' },
          { code: 17, codeName: '自修店' },
          { code: 18, codeName: '二级网点' },
          { code: 19, codeName: '车工坊C1' },
          { code: 20, codeName: '车工坊C2' },
          { code: 21, codeName: '车工坊B' },
          { code: 22, codeName: '德科品牌授权经销商' },
            { code: 0, codeName: '无' }
        ],
    },
    {
        title: "状态",
        name: "status",
        dataIndex: "status",
        tableItem: {},
        searchItem: {
          type: "select",
        },
        dict: [
          {code: 1, codeName: '有效'},
          {code: 0, codeName: '无效'}
        ],
        formItem: {
          initialValue: 1,
          type: 'radio'
        }
    },

];

const templateConfig = {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns,
        searchBarProps:{
          buttonSort: ['add','delete'],
          collapse: false,
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/dealerNewPersonTrain/requirementPartTimePositionAdd'
                }
              }
            },
            {
              key: "delete",
              custom: true,
              needSelect: true,
              params: {icon: "delete", children: "删除", type: "danger"},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "delete",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  if (!rows) return;
                  if ($$.isArray(rows) && !rows.length) return;
                  const content = '删除后数据不可恢复，您确定要删除选中的内容吗？'
                  let ids = [];
                  rows.forEach(e => {
                    if (e['rowKey']){
                      ids.push(e['rowKey']);
                    }
                  });
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        ids
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              },
              recordChangeParams: ({ record, rows }) => {
                let disabled = 0;
                if (rows && rows instanceof Array && rows.length>0){
                  rows.forEach(item => {
                    let {dataSource} =item;
                    if (dataSource != null && dataSource != 1){
                      disabled = 1;
                    }
                  })
                }else {
                  disabled = 1;
                }
                return { disabled: disabled }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          selectType: 'checkbox',
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['update','enableOrDisable'],
        rowOperateView: [
          {
            key: "update",
            custom: true,
            params: { children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/dealerNewPersonTrain/requirementPartTimePositionUpd"
              }
            },
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: {},//状态  0无效  1有效
            textFormat: {
              recordKey: 'status',
              dirt: {  1: '禁用', 0: '启用' }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['status'] === 0 ? "启用" : "禁用"
                  }该岗位兼职？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      status: record['status'] === 1 ? 0 : 1,
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
        ],
        rowOperateProps: {
          width: 120,
          fixed: 'right',
        },
        commonOperate: {
          add: true,
          delete: true,
          edit: true
        }
      }
    }
}

const apis = {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {}
      }
    },
    update: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@update`,
        apiParams: {}
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {}
      }
    },
    enable: {
      path: `${componentName}/enable`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {}
      }
    }
}



let reduxTemplateConfig = (args) => {
    return {
      apis,
      componentName,
      initApiKeys: ['list'],
      needLoading: true,
      ...args
    }
};

export {reduxTemplateConfig, templateConfig};
